export enum SoundType {
  SYSTEM_ATMOS = 'ATMOS',
  SYSTEM_5_1 = '5.1',
}
